"use client";

import { KnowledgeSourceFolderIcon } from "@/components/knowledge-sources/provider-icon";
import { Badge } from "@/components/ui/badge";
import { Switch } from "@/components/ui/switch";
import { Loader2 } from "lucide-react";
import { useTranslations } from "next-intl"



type KnowledgeBaseFolderRowProps = {
  name: string;
  sourceType?: string | null;
  documentCount: number;
  selectedDocumentCount: number;
  checked: boolean;
  isBusy: boolean;
  disabled: boolean;
  onToggle: () => void;
};

export function KnowledgeBaseFolderRow({
  name,
  sourceType,
  documentCount,
  selectedDocumentCount,
  checked,
  isBusy,
  disabled,
  onToggle,
}: KnowledgeBaseFolderRowProps) {

  const tUi = useTranslations("AgentTools.AgentsSharedKnowledgeBaseFolderRow")

  return (
    <label
      className={`flex items-start justify-between gap-3 rounded-lg border p-3 transition-colors sm:items-center sm:p-4 ${
        disabled
          ? "cursor-not-allowed opacity-60"
          : "cursor-pointer"
      } ${
        checked
          ? "border-purple-300 bg-purple-50"
          : "border-gray-200 hover:bg-muted/50"
      }`}
    >
      <div className="flex min-w-0 items-start gap-3">
        <div
          className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${
            checked ? "bg-purple-200" : "bg-gray-100"
          }`}
        >
          {isBusy ? (
            <Loader2 className="h-5 w-5 animate-spin text-purple-600" />
          ) : (
            <KnowledgeSourceFolderIcon
              sourceType={sourceType}
              className={`h-5 w-5 ${
                checked ? "text-purple-600" : "text-gray-500"
              }`}
            />
          )}
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <span className="break-words font-medium">{name}</span>
            <Badge
              variant="outline"
              className="border-purple-300 bg-white text-xs text-purple-700"
            >
              <span key={tUi("folder")}>{tUi("folder")}</span></Badge>
          </div>
          <div key={isBusy
              ? checked
                ? tUi("removingFolder")
                : tUi("addingFolder")
              : selectedDocumentCount > 0 && !checked
                ? tUi("value0OfValue1DocumentsSelected", { value0: String(selectedDocumentCount), value1: String(documentCount) })
                : tUi("value0DocumentValue1", { value0: String(documentCount), value1: String(documentCount === 1 ? "" : "s") })} className="break-words text-sm text-muted-foreground">
            {isBusy
              ? checked
                ? tUi("removingFolder")
                : tUi("addingFolder")
              : selectedDocumentCount > 0 && !checked
                ? tUi("value0OfValue1DocumentsSelected", { value0: String(selectedDocumentCount), value1: String(documentCount) })
                : tUi("value0DocumentValue1", { value0: String(documentCount), value1: String(documentCount === 1 ? "" : "s") })}
          </div>
        </div>
      </div>
      <Switch
        className="mt-1 shrink-0 sm:mt-0"
        checked={checked}
        disabled={disabled}
        onCheckedChange={onToggle}
      />
    </label>
  );
}
